import { render, staticRenderFns } from "./testInfo.vue?vue&type=template&id=03d04899&scoped=true"
import script from "./testInfo.vue?vue&type=script&lang=js"
export * from "./testInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d04899",
  null
  
)

export default component.exports